type Timer = ReturnType<typeof setTimeout>;

type SchedulerRuntime = {
  setTimeout: (callback: () => void, delay: number) => Timer;
  clearTimeout: (timer: Timer) => void;
};

const browserRuntime: SchedulerRuntime = {
  setTimeout: (callback, delay) => setTimeout(callback, delay),
  clearTimeout: timer => clearTimeout(timer),
};

/** Batch a burst without retaining payloads or repeatedly aborting REST calls. */
export function createNotificationUpdateScheduler(
  flush: () => boolean,
  runtime: SchedulerRuntime = browserRuntime
) {
  let pending = false;
  let disposed = false;
  let timer: Timer | null = null;

  const schedule = () => {
    if (disposed || !pending || timer !== null) return;

    // Fixed window so continuous events cannot starve the UI.
    timer = runtime.setTimeout(() => {
      timer = null;
      if (disposed || !pending) return;

      pending = false;
      if (!flush()) pending = true;
    }, 500);
  };

  return {
    request() {
      if (disposed) return;

      pending = true;
      schedule();
    },
    retryPending: schedule,
    dispose() {
      disposed = true;
      pending = false;
      if (timer !== null) runtime.clearTimeout(timer);
      timer = null;
    },
  };
}
